﻿import React, { useState, useEffect } from 'react';
import { NoteObject } from '../../models/note-object';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, NoteType } from '../../models/enums';

import TextArea from 'devextreme-react/text-area';

export interface Props {
    noteType?: NoteType;
    parentId?: string;
    height?: string;
    readOnly?: boolean;
}

export default function TextNoteEditor(props: Props) {
    const [note, setNote] =
        useState<NoteObject>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getNote();
    }, [props.parentId]);

    return (
        <div>
            <div id="textNoteTextArea" >
                <TextArea height={props.height ? props.height : undefined}
                    value={note && note.text ? note.text : undefined} readOnly={props.readOnly}
                    onValueChanged={onTextAreaTextChanged} />
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                    onClose={onGlobalDialogClose} />
            }
        </div>
    );

    async function onTextAreaTextChanged(e: any) {
        if (!note)
            return;

        if (note.text === e.value)
            return;
        else {
            const updatedNote = { ...note };
            updatedNote.text = e.value;

            //in order to support non-Latin characters, have to first encode to UTF-8 byte
            updatedNote.base64Blob = encodeBase64(e.value);
            //original:
            //updatedNote.base64Blob = btoa(e.value);

            setNote(updatedNote);

            await upsertNote(updatedNote)
                .then(() => {
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Note");
                });
        }
    }    
       
    // get functions

    async function getNote() {
        if (props.parentId && props.noteType) {
            await CrudFunctions.getData(`notes/notesbyparentidandnotetype/${props.parentId}/${props.noteType}`)
                .then(data => {
                    if (data && data.length > 0) {
                        let returnedNote = data[0] as NoteObject;

                        if (returnedNote) {
                            returnedNote.text = decodeBase64(returnedNote.base64Blob);
                            //original
                            //returnedNote.text = atob(returnedNote.base64Blob);

                            setNote(returnedNote);
                        }
                    }
                    else { //create a new note
                        let newNote: NoteObject = {
                            noteType: props.noteType,
                            parentId: props.parentId,
                        }

                        setNote(newNote);
                    }
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Note");
                });
        }
    }

    //PUT functions

    async function upsertNote(note: NoteObject) {
        return CrudFunctions.putData("notes/note", note);
    }

    // DELETE functions

    async function deleteNote(noteId: string) {
        return CrudFunctions.deleteData(`notes/note/${noteId}`);
    }

    async function onDeleteNote() {
        if (note && note.noteId) {
            await deleteNote(note.noteId)
                .then(() => {

                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Note");
                });
        }
    }

    //other

    function encodeBase64(text) {
        return btoa(String.fromCharCode(...new TextEncoder().encode(text)));
    }

    function decodeBase64(base64) {
        return new TextDecoder().decode(Uint8Array.from(atob(base64), c => c.charCodeAt(0)));
    }

    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}

